<template>
  <div class="adviser-section-heading" :class="{ centered }">
    <h1 :class="`variant-${variant}`">
      {{ title
      }}<span v-if="titleLight" class="light">&nbsp;{{ titleLight }}</span>
    </h1>
    <p v-if="subtitle" class="sub-line">{{ subtitle }}</p>
  </div>
</template>

<script>
  // Section heading for the adviser pages. Variant "a" (28/34) is the
  // default section heading; "b" (28/32, tighter tracking) is used for
  // Grow/Boost, Incentives, Terms and the channel selectors. See spec 2.2.
  export default {
    name: 'AdviserSectionHeading',
    props: {
      title: {
        type: String,
        required: true,
      },
      titleLight: {
        type: String,
        default: '',
      },
      subtitle: {
        type: String,
        default: '',
      },
      variant: {
        type: String,
        default: 'a',
        validator: value => ['a', 'b'].includes(value),
      },
      centered: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../../constants/styles/adviser-pages.scss';

  .adviser-section-heading {
    h1 {
      @include adviser-heading-a;
      &.variant-b {
        @include adviser-heading-b;
      }
      .light {
        font-weight: 300;
      }
    }
    .sub-line {
      @include adviser-sub-line;
      margin: 24px 0 0 0;
    }
    &.centered {
      text-align: center;
      .sub-line {
        color: $adviser-text-muted-center;
        max-width: 647px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 10px;
      }
    }
  }
</style>
